import React from "react";
import { defaultState } from "tsi-common-react/src/apps/reviews/defaults";
import { clearFilters } from "tsi-common-react/src/apps/reviews/reducers";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";
import { t } from "ttag";

import { Review } from "../Review";

import styles from "./index.module.scss";

export const ReviewList = () => {
    const dispatch = useAppDispatch();

    const reviews = useAppSelector(
        (state) => (state.reviews || defaultState).data.reviews,
    );

    if (reviews.length === 0) {
        return (
            <div className={styles.reviewlistNoReviewsFound}>
                <p>
                    {t`Sorry, we could not find any reviews within your criteria.`}
                </p>
                <p>
                    <button
                        className="button cta-button"
                        onClick={() => dispatch(clearFilters())}
                    >
                        {t`Clear filters and try again?`}
                    </button>
                </p>
            </div>
        );
    }
    return (
        <div className="reviewlist">
            {reviews.map((data) => (
                <Review key={`${data.product_id}-${data.id}`} review={data} />
            ))}
        </div>
    );
};
